import { Component, Input } from "@angular/core";
import { DatePipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { TaskEvent } from "@models/task-request";
import { EventStatusPipe } from "../../../shared/pipes/event-status.pipe";

@Component({
  selector: "app-event-info-card",
  imports: [DatePipe, RouterLink, EventStatusPipe],
  templateUrl: "./event-info-card.component.html",
  styleUrl: "./event-info-card.component.scss",
})
export class EventInfoCardComponent {
  @Input({ required: true }) event!: TaskEvent;
}
